import React, { useEffect, useState } from "react";

export default function EntryTimer({ entryTime }) {
  const [remaining, setRemaining] = useState(getRemaining(entryTime));

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(getRemaining(entryTime));
    }, 1000);
    return () => clearInterval(interval);
  }, [entryTime]);

  // Si el tiempo ha terminado, mostrar la fecha, día y hora de entrada
  if (remaining.total <= 0) {
    if (!remaining.parsedTime || isNaN(remaining.parsedTime.getTime())) {
      return <span className="text-gray-500 font-mono">—</span>;
    }
    
    const parsedTime = remaining.parsedTime;
    
    // Formatear la fecha como DD/MM/AAAA
    const day = String(parsedTime.getDate()).padStart(2, '0');
    const month = String(parsedTime.getMonth() + 1).padStart(2, '0');
    const year = String(parsedTime.getFullYear());
    
    // Formatear la hora como HH:MM
    const hours = String(parsedTime.getHours()).padStart(2, '0');
    const minutes = String(parsedTime.getMinutes()).padStart(2, '0');
    
    return (
      <span className="text-gray-600 font-mono text-xs">
        {day}/{month}/{year} {hours}:{minutes}
      </span>
    );
  }

  return (
    <span className="text-yellow-600 font-mono">
      {String(remaining.minutes).padStart(2, '0')}:
      {String(remaining.seconds).padStart(2, '0')}
    </span>
  );
}

function getRemaining(entryTime) {
  let parsedTime;
  if (typeof entryTime === "string") {
    // 👇 Append 'Z' if not present
    parsedTime = new Date(entryTime.endsWith("Z") ? entryTime : entryTime + "Z");
  } else {
    parsedTime = new Date(entryTime);
  }

  if (isNaN(parsedTime.getTime())) {
    console.warn("⚠️ Invalid entryTime:", entryTime);
    return { total: 0, minutes: 0, seconds: 0, parsedTime: null };
  }

  const total = 20 * 60 * 1000 - (Date.now() - parsedTime);
  const clampedTotal = Math.max(0, total);
  // Si el tiempo ha terminado, retornar valores 0 pero mantener el total original para la verificación
  const minutes = total <= 0 ? 0 : Math.floor((clampedTotal / 1000 / 60) % 60);
  const seconds = total <= 0 ? 0 : Math.floor((clampedTotal / 1000) % 60);
  return { total, minutes, seconds, parsedTime };
}

